<template>
  <div ref="mychart" :style="{ height: height, width: width }"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "MaodunChart",
  props: {
      width: {
          type: String,
          default: '430px'
      },
      height: {
          type: String,
          default: '238px'
      },
      dataList:{
          type: Array,
          default: () => []
      }
  },
  data() {
      return {
          chart: null
      }
  },
  watch: {
      dataList(){
          this.initChart()
      }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.mychart);
      this.chart.setOption({
        grid:{
          top: 8, right: 60, bottom: 10, left: 30,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          data: this.dataList.map(obj => (obj.name)),
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: '#fff',
            fontSize: 10
          },
          offset: 5
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            fontSize: 12
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: this.dataList.map(obj => (obj.rate)),
            type: 'bar',
            barWidth: '10px',
            label: {
              show: true,
              position: 'right',
              color: '#fff',
              formatter: '{@score}' + '%'
            },
            itemStyle: {
              borderRadius: [10, 10, 10, 10],
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: 'rgba(5,104,156,0.5)' },
                { offset: 1, color: '#00AEFF' }
              ])
            },
          }
        ]
      })
    },
  },
}
</script>
<style scoped></style>